import { createContext, useContext, ReactNode } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage"


type CartProviderProps = {
  children: ReactNode;
}

type CartItemProps = {
  id: number
  quantity: number
}

type CartContextProps = {
  getItemQuantity: (id: number) => number
  removeFromCart: (id: number) => void
  addToCart: (id: number) => void
  cartQuantity: number
  cartItems: CartItemProps[]
}
const CartContext = createContext({} as CartContextProps);

//create custom hook for getting our Context
export function useCart() {
  return useContext(CartContext);
}

//Provider function to give all the values and rendering out the cart

export function CartProvider({ children }: CartProviderProps) {
  
  const [cartItems, setCartItems] = useLocalStorage<CartItemProps[]>("default-cart",[]);
  
  
  const cartQuantity = cartItems.reduce(
    (quantity, item) => item.quantity + quantity, 0
  )

  function getItemQuantity(id: number) {
    return cartItems.find(item => item.id === id)?.quantity ||0 ;
  }

  function addToCart(id: number) {
    setCartItems(currentItem => {
      if (currentItem.find(item => item.id === id) == null) {
        alert("Course has been Added Successfully!")
        return [...currentItem, { id, quantity: 1 }];
      } else {
        alert("This Course has already been added to Cart!");
        return currentItem.map(item => {
          
          return item
        })
        
      }
    })
  }

  function removeFromCart(id: number) { 
    setCartItems(currentItem => {
      return currentItem.filter(item => item.id !== id);
    })
  }

  return <CartContext.Provider value={{getItemQuantity,removeFromCart,addToCart,cartItems,cartQuantity}} >
    {children}
  </CartContext.Provider>
}